import * as chatSettings from '@wix/auto_sdk_forms_chat-settings';
import * as interactiveFormSessions from '@wix/auto_sdk_forms_interactive-form-sessions';
import * as forms from '@wix/auto_sdk_forms_forms';
import * as formSpamSubmissionReports from '@wix/auto_sdk_forms_form-spam-submission-reports';
import * as submissions from '@wix/auto_sdk_forms_submissions';

export {
  chatSettings,
  interactiveFormSessions,
  forms,
  formSpamSubmissionReports,
  submissions,
};
